import React from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  FormControlLabel,
  Switch,
} from "@mui/material";

interface TagsAndSettingsSectionProps {
  formData: {
    tags: string;
    content: string;
    isActive: boolean;
  };
  onChange: (field: string, value: any) => void;
}

const TagsAndSettingsSection: React.FC<TagsAndSettingsSectionProps> = ({
  formData,
  onChange,
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label='Tags'
            placeholder='wellness, meditation, stress-relief'
            value={formData.tags}
            onChange={(e) => onChange("tags", e.target.value)}
            helperText='Separate tags with commas to help users find this resource'
            InputProps={{
              startAdornment: (
                <Typography sx={{ mr: 1, color: "text.secondary" }}>
                  🏷️
                </Typography>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                minHeight: 64,
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label='Content'
            placeholder='Main content of the resource (for articles, tools, etc.)'
            value={formData.content || ""}
            onChange={(e) => onChange("content", e.target.value)}
            helperText='Main content or description of the resource'
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                minHeight: 100,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Switch
                checked={formData.isActive}
                onChange={(e) => onChange("isActive", e.target.checked)}
              />
            }
            label='Active'
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TagsAndSettingsSection;

